// eslint-disable-next-line import/no-extraneous-dependencies
import parseISO from 'date-fns/parseISO';
import { formatInTimeZone, utcToZonedTime } from 'date-fns-tz';
import Schedule from './schedule';
import tz from './data/tz.json';
import tzBackwards from './data/tz-backwards.json';


const defaultTimezone = 'Europe/London';

function getCurrentTz() {
  let answer = defaultTimezone;
  if (Intl && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions) {
    answer = Intl.DateTimeFormat().resolvedOptions().timeZone || defaultTimezone;
  }
  // Check if the timezone is an old one that has to be mapped to a current IANA value
  return tzBackwards.mapping[answer] ? tzBackwards.mapping[answer] : answer;
}

function formatFullDateTime(isoTime, timezone) {
  const hourCycle = Intl && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions
    ? Intl.DateTimeFormat(navigator.language,  { hour: 'numeric' }).resolvedOptions().hourCycle
    : 'h12';

  let timeFormat;
  switch (hourCycle) {
    case 'h12':
    case 'h11':
      timeFormat = 'hh:mmaaa';
      break;
    case 'h23':
    case 'h24':
      timeFormat = 'HH:mm';
      break;
    default:
      timeFormat = 'h:mmaaa';
      break;
  }

  if (isoTime.includes('/')) {
    const [isoFrom, isoTo] = isoTime.split('/').map(part => part.trim());
    const from = parseISO(isoFrom);
    const to = parseISO(isoTo);
    const zonedFrom = utcToZonedTime(from, timezone);
    const zonedTo = utcToZonedTime(to, timezone);
    const formatTo = [];
    if (zonedFrom.getMonth() !== zonedTo.getMonth()
      || zonedFrom.getDate() !== zonedTo.getDate()
      || zonedFrom.getFullYear() !== zonedTo.getFullYear()) {
      formatTo.push('MMMM d,');
    }
    if (zonedFrom.getFullYear() !== zonedTo.getFullYear()) {
      formatTo.push('yyyy,');
    }
    formatTo.push(timeFormat);

    const resultFrom = formatInTimeZone(from, timezone, `MMMM d, yyyy, ${timeFormat}`);
    const resultTo = formatInTimeZone(to, timezone, formatTo.join(' '));
    const resultTimezone = formatInTimeZone(from, timezone, 'zzzz');

    return `${resultFrom} — ${resultTo} (${resultTimezone})`;
  }

  return formatInTimeZone(parseISO(isoTime), timezone, `MMMM d, yyyy, ${timeFormat} (zzzz)`);
}

if ($('[data-component=tz-selector]').length > 0) {
  const $scheduleContainer = $('[data-component=schedule]');
  const entries = Array.from($scheduleContainer.find('.entries .entry'))
    .map((entry) => ({
      time: parseISO($(entry).attr('data-time')),
      body: $(entry).clone(),
    }));

  const schedule = new Schedule(entries);

  const $select = $('[data-component=tz-selector]').first()
    .html(tz.timezones.map(id => `<option value="${id}">${id.replace('_', ' ')}</option>`).join(''))
    .selectpicker()
    .selectpicker('val', getCurrentTz())
    .on('change', () => {
      const timezone = $select.selectpicker('val');
      if (timezone) {
        $scheduleContainer.html(schedule.render(timezone));
        $scheduleContainer.addClass('ready');

        $('[data-time-convert]').each((i, el) => {
          const $el = $(el);
          $el.text(formatFullDateTime($el.attr('data-time-convert'), timezone));
        });
      }
    });
  $select.trigger('change');
}
